export const omit = (obj, ...keys) => {
    const _ = Object.assign({}, obj);
    keys.forEach((key) => delete _[key]);
    return _;
};
